import { defineMessages } from "react-intl";
import { of } from "rxjs";
import { filter, catchError } from "rxjs/operators";
import { isActionOf } from "typesafe-actions";
import { maxServerDownloadPageSize, maxPageSize } from "../../api/types.js";
import { getFilterString } from "../../api/utils.js";
import "immer";
import "moment-timezone";
import "@apollo/client/errors";
import "@apollo/client";
import "graphql";
import "@opentelemetry/api";
import "../../otel/TraceProvider.js";
import "react";
import "react-error-boundary";
import { mergeMap, map } from "../../otel/rxjs.js";
import "@opentelemetry/context-zone";
import "@opentelemetry/exporter-trace-otlp-http";
import "@opentelemetry/instrumentation";
import "@opentelemetry/instrumentation-document-load";
import "@opentelemetry/instrumentation-xml-http-request";
import "@opentelemetry/resources";
import "@opentelemetry/sdk-trace-web";
import "@opentelemetry/semantic-conventions";
import "@apollo/client/link/subscriptions";
import "@apollo/client/utilities";
import "cross-fetch";
import "graphql-ws";
import "../../node_modules/moment/dist/moment.js";
import "rxjs/ajax";
import { BaseEpicsBuilder } from "../epicsBuilder.js";
import "../actions.js";
import { fileActions } from "../file/actions.js";
import { getMessageActions } from "../message/actions.js";
import "react-redux";
import "redux";
import { downloadActions } from "./actions.js";
const downloadEpicsLocalized = defineMessages({
  failedDownload: {
    id: "DownloadEpicsBuilder_failedDownload",
    defaultMessage: "Failed to download {filename}"
  },
  totalCountErrorMessage: {
    id: "DownloadEpicsBuilder_totalCountErrorMessage",
    defaultMessage: "Download limit exceeded ({maxPageSize} items). Please adjust your filter and try again."
  },
  serverDownloadLimitWarning: {
    id: "DownloadEpicsBuilder_serverDownloadLimitWarning",
    defaultMessage: "Only the first {limit} records will be included in the export file due to system limits."
  }
});
class DownloadEpicsBuilder extends BaseEpicsBuilder {
  _fileFactory;
  _messageActions;
  _serverBaseUrl;
  constructor(fileFactory, serverBaseUrl) {
    super();
    this._fileFactory = fileFactory;
    this._messageActions = getMessageActions();
    this._serverBaseUrl = serverBaseUrl;
  }
  buildEpicList() {
    return [
      this.buildStartDownloadEpic(),
      this.buildFetchDownloadDataRequestEpic(),
      this.buildFetchDownloadDataSuccessEpic(),
      this.buildFetchDownloadDataFailureEpic(),
      this.buildDownloadFileEpic()
    ];
  }
  buildStartDownloadEpic() {
    return (action$) => action$.pipe(
      filter(isActionOf(downloadActions.startDownload)),
      mergeMap(({ payload }) => {
        const resultActions = [];
        if (payload?.mode === "server") {
          if (payload?.total > maxServerDownloadPageSize) {
            resultActions.push(
              this._messageActions.saveMessage({
                message: downloadEpicsLocalized.serverDownloadLimitWarning,
                values: { limit: `${maxServerDownloadPageSize}` },
                mode: "warning"
              })
            );
          }
          resultActions.push(downloadActions.fetchDownloadData.request(payload));
        } else if (payload?.total > maxPageSize) {
          resultActions.push(
            this._messageActions.saveMessage({
              message: downloadEpicsLocalized.totalCountErrorMessage,
              values: { maxPageSize: `${maxPageSize}` },
              mode: "error"
            })
          );
        } else {
          resultActions.push(downloadActions.fetchDownloadData.request(payload));
        }
        return of(...resultActions);
      })
    );
  }
  buildFetchDownloadDataRequestEpic() {
    return (action$) => action$.pipe(
      filter(isActionOf(downloadActions.fetchDownloadData.request)),
      mergeMap(({ payload }) => {
        const { total, strategy, keys, worksheetKeys, headers, filename, mode, hasSummary } = payload;
        const pageFilterKey = "page";
        const sizeFilterKey = "size";
        const filter2 = getFilterString(
          payload?.filter,
          true,
          { key: pageFilterKey, value: "1" },
          { key: sizeFilterKey, value: `${maxPageSize}` }
        );
        const failedAction = downloadActions.fetchDownloadData.failure({
          message: downloadEpicsLocalized.failedDownload,
          values: { filename },
          mode: "error"
        });
        return strategy.process({ keys, filter: filter2, mode, headers, filename, total, hasSummary }).pipe(
          mergeMap((response) => {
            let result = of(failedAction);
            if (response?.status === "Success") {
              if (response.mode === "client" && response.items?.length) {
                result = this._fileFactory.createFile(response.items, worksheetKeys, headers).pipe(
                  map(
                    (arrayBuffer) => downloadActions.fetchDownloadData.success({ arrayBuffer, filename, mode: response.mode })
                  ),
                  catchError(() => of(failedAction))
                );
              } else if (response.mode === "server" && response.link) {
                result = of(downloadActions.fetchDownloadData.success({ link: response.link, mode: response.mode }));
              }
            }
            return result;
          }),
          catchError(() => of(failedAction))
        );
      })
    );
  }
  buildFetchDownloadDataSuccessEpic() {
    return (action$) => action$.pipe(
      filter(isActionOf(downloadActions.fetchDownloadData.success)),
      map(({ payload }) => downloadActions.downloadFile(payload))
    );
  }
  buildFetchDownloadDataFailureEpic() {
    return (action$) => action$.pipe(
      filter(isActionOf(downloadActions.fetchDownloadData.failure)),
      map(({ payload }) => this._messageActions.saveMessage(payload))
    );
  }
  buildDownloadFileEpic() {
    return (actions$) => actions$.pipe(
      filter(isActionOf(downloadActions.downloadFile)),
      mergeMap((action) => {
        const { arrayBuffer, filename, mode, link } = action.payload;
        let result = of();
        if (mode === "client") {
          result = of(
            fileActions.download({
              file: new Blob([arrayBuffer]),
              title: filename,
              type: "csv"
            })
          );
        } else {
          window.open(new URL(link, this._serverBaseUrl).href, "_self");
        }
        return result;
      })
    );
  }
}
export {
  DownloadEpicsBuilder,
  downloadEpicsLocalized
};
//# sourceMappingURL=epics.js.map
